import { defaultTheme } from '@ant-design/compatible';
import { ThemeConfig } from 'antd';
import { AliasToken } from 'antd/es/theme/interface/alias';
import sharedVariables from 'styles/shared/variables.scss';

/*
* DefaultTheme and 'antd/dist/reset.css';
 were used to return styles from antd v4
* */

export interface CustomThemeConfig extends Partial<AliasToken> {
  components?: ThemeConfig['components'];
}

export const getAntdThemeConfig = (props: CustomThemeConfig): ThemeConfig => {
  return {
    token: {
      ...defaultTheme.token,
      ...props,
      colorPrimary: sharedVariables.blue_main,
      colorError: sharedVariables.red500,
      colorErrorBorderHover: sharedVariables.red500,
      colorPrimaryHover: sharedVariables.blue500,
      colorBorder: sharedVariables.grey200,
    },
    components: {
      ...defaultTheme.components,
      Divider: {
        margin: 8,
      },
      Menu: {
        ...props.components?.Menu,
        itemSelectedBg: sharedVariables.blueLight10,
        itemSelectedColor: sharedVariables.blue_main,
        itemHoverColor: sharedVariables.blue_main,
        iconSize: 24,
      },
      Segmented: {
        ...defaultTheme.components?.Segmented,
        borderRadius: 8,
        motionEaseInOut: 'none',
        motionDurationMid: '0',
        motionDurationSlow: '0',
        controlPaddingHorizontal: 22,
        borderRadiusXS: 6,
        borderRadiusSM: 6,
        borderRadiusLG: 6,
      },
      Select: {
        ...defaultTheme.components?.Select,
        colorBgContainerDisabled: sharedVariables.grey50,
        boxShadow: 'none',
        controlItemBgHover: sharedVariables.blue50,
      },
      Dropdown: {
        ...defaultTheme.components?.Dropdown,
        controlItemBgHover: sharedVariables.blue50,
      },
      Input: {
        ...defaultTheme.components?.Input,
        activeBorderColor: sharedVariables.blue500,
        colorBgContainerDisabled: sharedVariables.grey50,
        hoverBorderColor: sharedVariables.grey400,
        boxShadow: 'none',
        activeShadow: 'none',
      },
      InputNumber: {
        ...defaultTheme.components?.InputNumber,
        activeBorderColor: sharedVariables.blue500,
        colorBgContainerDisabled: sharedVariables.grey50,
        hoverBorderColor: sharedVariables.grey400,
        boxShadow: 'none',
        activeShadow: 'none',
      },
      Checkbox: {
        ...defaultTheme.components?.Checkbox,
      },
      Button: {
        ...defaultTheme.components?.Button,
        fontSize: 12,
        controlHeightSM: 24,
        controlHeight: 32,
        controlHeightLG: 48,
        borderRadius: 4,
        borderRadiusLG: 4,
        borderRadiusSM: 4,
        borderRadiusXS: 4,
      },
      Radio: {
        colorPrimary: sharedVariables.blue500,
        radioSize: 16,
        dotSize: 8,
      },
      Progress: {
        colorPrimary: sharedVariables.blue_main,
      },
      Switch: {
        handleBg: sharedVariables.white,
        trackMinWidth: 40,
      },
    },
    inherit: defaultTheme.inherit,
    hashed: defaultTheme.hashed,
  };
};

export const userGlobalStyles: CustomThemeConfig = {
  fontSize: 14,
  fontFamily: 'Roboto, sans-serif',
  components: {
    Menu: {
      ...defaultTheme.components?.Menu,
    },
  },
};

export const adminGlobalStyles: CustomThemeConfig = {
  fontSize: 13,
  fontFamily: 'Roboto, sans-serif',
  components: {
    Menu: {
      itemHeight: 38,
    },
  },
};
